/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/models/lieferkunde-group.ts.
 */
import {Lieferkunde} from './lieferkunde';

/**
 * Zweck: Beschreibt class LieferkundeGroup und ihren Daten- oder Funktionsvertrag.
 */
export class LieferkundeGroup {
  a3KundeNr: number;
  label: string;
  lieferkunden: Lieferkunde[] = [];
}
